import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HeaderServiceService {

  constructor(private http: HttpClient) { }

  getContacts() {
    let headers = new HttpHeaders({
      'Accept': 'application/json',
      'Authorization':`Bearer ${localStorage.getItem("token")}`
    })
    return headers;
  }
}
